import { BackendClient, type BackendTypes } from '@tf/api';

export const writeSegmentsMutation = async (
	input: BackendTypes.SegmentsWritePayload,
): Promise<BackendTypes.SegmentsWriteData> => {
	const api = BackendClient.getInstance();
	const r = await api.segmentsWrite(input);

	if (!r.ok) {
		const text = await r.text().catch(() => '');
		throw new Error(`Segments write failed: ${r.status}${text ? ` — ${text}` : ''}`);
	}

	const text = await r.text();
	if (!text) {
		return [] as unknown as BackendTypes.SegmentsWriteData;
	}

	return JSON.parse(text) as BackendTypes.SegmentsWriteData;
};
